import { gql } from '@apollo/client';

import { FillInTheBlanksExercise, UpdateFillInTheBlanksExerciseInput } from '../../types';
import { fillInTheBlanksExerciseFragment } from '../fragments';

export interface UpdateFillInTheBlanksExerciseMutationVariables {
  courseId: string;
  subjectId: string;
  exerciseId: string;
  input: UpdateFillInTheBlanksExerciseInput;
}

export interface UpdateFillInTheBlanksExerciseMutationResult {
  fillInTheBlanksExercise: FillInTheBlanksExercise;
}

export const updateFillInTheBlanksExerciseMutation = gql`
  mutation UpdateFillInTheBlanksExerciseMutation(
    $courseId: String!
    $subjectId: String!
    $exerciseId: String!
    $input: UpdateFillInTheBlanksExerciseMutationInput!
  ) {
    fillInTheBlanksExercise(courseId: $courseId, subjectId: $subjectId, exerciseId: $exerciseId, input: $input)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises/{args.exerciseId}", method: "PUT") {
      ...FillInTheBlanksExercise
    }
  }
  ${fillInTheBlanksExerciseFragment}
`;
